const applyStripeEnv = () => {
  const ndenv = process.env.REACT_APP_ENV_CODE;

  switch (ndenv) {
    case 'local':
      return {
        ApiKey: 'pk_test_GEjjSy1vUs3evFD4Cw3VwBeq',
      };
    case 'dev':
      return {
        ApiKey: 'pk_test_GEjjSy1vUs3evFD4Cw3VwBeq',
      };
    case 'stg':
      return {
        ApiKey: 'pk_test_GEjjSy1vUs3evFD4Cw3VwBeq',
      };
    case 'prd':
      return {
        ApiKey: 'pk_live_iOL9PWvmILWJyFypmjFpaFur',
      };
    default:
      return '';
  }
};
const StripeConfig = applyStripeEnv();

function configureStripe() {
  return StripeConfig;
}

export default configureStripe;
